angular
  .module("AccountingBoxApp")
  .controller("OpenSalesCtrl", function(
    $scope,
    $rootScope,
    $http,
    $state,
    FileUploader,
    LoopBackAuth,
    Journal,
    Account,
    Rapporting,
    Sale
  ) {
    $scope.order = {
      by: "invoiceDate",
      reverse: false,
      filter: ""
    };

    $scope.options = {
      language: "nl",
      todayHighlight: true,
      format: "dd-mm-yyyy",
      autoclose: true
    };

    var vm = this;
    vm.search = "";
    vm.loading = false;

    vm.date = new Date();
    vm.executionDate = new Date();

    vm.checkedSaleIds = [];
    vm.sales = [];

    vm.checked = function(saleId) {
      return vm.checkedSaleIds.includes(saleId);
    };

    vm.allChecked = function() {
      return vm.checkedSaleIds.length === vm.sales.length;
    };

    vm.toggleAllChecked = function() {
      if (vm.allChecked()) {
        vm.checkedSaleIds = [];
      } else {
        vm.checkedSaleIds = vm.sales.map(function(sale) {
          return sale.id;
        });
      }
    };

    vm.toggleSale = function(saleId) {
      if (vm.checked(saleId)) {
        vm.checkedSaleIds = vm.checkedSaleIds.filter(function(id) {
          return id !== saleId;
        });
      } else {
        vm.checkedSaleIds.push(saleId);
      }
    };

    vm.generateSepaBatch = function() {
      $http
        .post(API_ENDPOINT + "/Sales/sepa-batch", {
          ids: vm.checkedSaleIds,
          executionDate: vm.executionDate
        })
        .then(function(response) {
          var headers = response.headers();
          var blob = new Blob([response.data], {
            type: headers["content-type"]
          });
          var fileName = "SEPA_incasso_batch_" +
              moment(vm.executionDate).format("DD-MM-YYYY") +
              ".xml";
          $rootScope.download(blob, fileName);
        }).catch(response => {
        console.log('error is',response);
          window.swal("Mislukt", response.data.error.message, "error");
        });
    };

    vm.filterData = function() {
      vm.sales = vm.result.openDebit.sales;
      vm.payments = vm.result.openDebit.payments;

      if(vm.search) {
        let search = vm.search.toLowerCase()
        vm.sales = vm.sales.filter(function(p) {
          return p.customer.name.toLowerCase().includes(search)
        })
        vm.payments = vm.payments.filter(function(p) {
          return p.invoice.customer.name.toLowerCase().includes(search)
        })
      }

      vm.totalInvoiceAmount = vm.sales.reduce(function(accumulator, invoice) {
        return accumulator + invoice.totalAmount;
      }, 0);
      vm.totalAmountDue = 0;
      vm.totalAmountDue = vm.sales.reduce(function(accumulator, invoice) {
        return accumulator + invoice.amountDue;
      }, vm.totalAmountDue);
      vm.totalAmountDue = vm.payments.reduce(function(accumulator, payment) {
        return accumulator - payment.amount;
      }, vm.totalAmountDue);
    }

      vm.dataChanged = function() {
      vm.loading = true;

      Rapporting.openDebit({ date: vm.date }, function(result) {
        vm.result = result;
        vm.loading = false;
        vm.filterData()
      });
    };

    // vm.dataChanged();

    vm.toTransaction = function(journalLine) {
      Journal.findById({ id: journalLine.journalId }, function(journal) {
        var to = journal.transactionType.toLowerCase() + "s";
        if (journal.transactionType.toLowerCase() === "journalentry") {
          to = "journalEntries";
        }
        $state.go("app.company.edit." + to, {
          id: journal.transactionId
        });
      });
    };

    vm.today = function() {
      return moment().format("L");
    };
  });
